import { render, staticRenderFns } from "./directionalSwipe.vue?vue&type=template&id=27d5199c&scoped=true&"
import script from "./directionalSwipeControl.js?vue&type=script&lang=js&"
export * from "./directionalSwipeControl.js?vue&type=script&lang=js&"
import style0 from "./directionalSwipe.css?vue&type=style&index=0&id=27d5199c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d5199c",
  null
  
)

export default component.exports